import type { Header } from "@tanstack/react-table";
import type { CSSProperties } from "react";
import { cn } from "../../utils";

export type ColumnResizerProps = {
  header: Header<any, any>;
  className?: string;
  style?: CSSProperties;
};

const ColumnResizer = ({ header, className, style }: ColumnResizerProps) => {
  if (!header.column.getCanResize()) {
    return null;
  }

  const resizeHandler = header.getResizeHandler();

  return (
    <div
      className={cn(
        "z-[2] absolute top-0 right-0 h-full w-1 select-none touch-none cursor-col-resize hover:bg-[#41875c]/45 active:bg-[#41875c]",
        className
      )}
      onDoubleClick={() => header.column.resetSize()}
      onTouchStart={resizeHandler}
      onMouseDown={resizeHandler}
      style={style}
    />
  );
};

export default ColumnResizer;
